<template>
  <div :class="$style.container">
    <div :class="$style.title">
      {{ $t('program.checkForNewVersion') }}
    </div>

    <div :class="$style.info">
      <div>{{ $t('program.installedVersion') }}</div>
      <div>{{ currentVersion }}</div>
    </div>
    <div :class="$style.info">
      <div>{{ $t('program.currentVersion') }}</div>
      <div>{{ latestVersion }}</div>
    </div>
    <div :class="$style.info">
      <div
        v-if="isLatestVersion"
        :class="$style.version"
      >
        {{ $t('program.latestVersionInstalled') }}
      </div>
      <div
        v-if="isUpdateSoftware"
        :class="$style.version"
      >
        {{ $t('program.updatesInfoLoaded') }}
      </div>
      <div
        v-if="!isLatestVersion && !isUpdateSoftware"
        :class="$style.version"
      >
        {{ $t('program.newVersionsAvailable') }}
      </div>
      <button
        :disabled="isLatestVersion || isUpdateSoftware"
        :class="$style.button"
        @click="checkForUpdates"
      >
        {{ $t('program.checkAvailability') }}
      </button>
    </div>
    <div
      v-if="latestVersionDescription"
      :class="$style.updateContainer"
    >
      <div :class="$style.updateText">
        {{ latestVersionTitle }}
      </div>
      <div :class="$style.updateFeature">
        {{ $t('program.currentVersionVsInstalled') }}
      </div>
      <ul :class="$style.updateList">
        <li
          v-for="(list, index) of latestVersionDescription"
          :key="index"
        >
          {{ list }}
        </li>
      </ul>
      <a
        :class="$style.link"
        :href="latestVersionLink"
        target="_blank"
      >
        {{ $t('program.viewMoreOnWebsite') }}
      </a>
    </div>
    <div :class="$style.title">
      {{ $t('program.checkForUpdates') }}
    </div>
    <form :class="$style.updateForm">
      <fieldset>
        <div>
          <input
            id="every_launch"
            v-model="updateCheckFrequency"
            type="radio"
            name="update_frequency"
            value="every_startup"
          >
          <label for="every_launch">{{ $t('program.onEveryLaunch') }}</label>
        </div>
        <div>
          <input
            id="every_day"
            v-model="updateCheckFrequency"
            type="radio"
            name="update_frequency"
            value="every_day"
          >
          <label for="every_day">
            {{ $t('program.every') }}
            <input
              id="day"
              v-model="selectedDay"
              type="number"
              name="day"
              min="1"
              max="365"
            >
            {{ $t('global.days') }}
          </label>
        </div>

        <div>
          <input
            id="do_not_check"
            v-model="updateCheckFrequency"
            type="radio"
            name="update_frequency"
            value="do_not_check"
          >
          <label for="do_not_check">{{ $t('program.doNotCheck') }}</label>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
  import Vue from 'vue';
  import VueToast from 'vue-toast-notification';

  Vue.use(VueToast);
  export default {
    computed: {
      isLatestVersion() {
        return this.$store.getters['software/isLatestVersion'];
      },
      isUpdateSoftware() {
        return this.$store.getters['software/isUpdateSoftware'];
      },
      currentVersion() {
        return this.$store.getters['software/currentVersion'];
      },
      latestVersion() {
        return this.$store.getters['software/latestVersion'];
      },
      latestVersionTitle() {
        return this.$store.getters['software/latestVersionTitle'];
      },
      latestVersionDescription() {
        return this.$store.getters['software/latestVersionDescription'];
      },
      latestVersionLink() {
        const currentUrl = this.$store.getters['software/latestVersionLink'];
        return currentUrl || `${this.$t('program.link')}news.html`;
      },

      updateCheckFrequency: {
        get() {
          return this.$store.getters['software/checkFrequency'];
        },
        set(value) {
          this.$store.dispatch('software/updateCheckFrequency', value);
        },
      },
      selectedDay: {
        get() {
          return this.$store.getters['software/selectedDay'];
        },
        set(value) {
          this.$store.dispatch('software/updateSelectedDay', value);
        },
      },
    },
    created() {
      this.$store.dispatch('software/initializeCheckFrequency');
      this.$store.dispatch('software/initializeSelectedDay');
    },
    methods: {
      getNewVersion() {
        Vue.$toast.open({
          message: this.$t('toast.updateInfoLoaded'),
          type: 'info',
          duration: 5000,
        });
      },
      async checkForUpdates() {
        await this.$store.dispatch('software/updateSoftwareInfo');
        this.getNewVersion();
      },
    },
  };
</script>

<style lang="scss" module>
  .container {
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    margin: 5px auto 15px 22px;
    width: 92%;
    padding: 15px 25px;
  }
  .title {
    font-weight: 500;
  }
  .info {
    display: grid;
    grid-template-columns: 250px 150px;
    column-gap: 20px;
    margin: 20px;
    height: 30px;
    align-items: center;
  }
  .button {
    cursor: pointer;
    height: 100%;
  }
  .link {
    margin: 20px 0;
    color: #1788ce;
  }
  .updateContainer {
    display: flex;
    flex-direction: column;
    margin: 20px 0;
    border: 1px solid #e3e3e3;
    padding: 0 20px;
  }
  .updateText {
    margin: 20px 0;
    font-weight: 500;
  }
  .updateFeature {
    color: #1788ce;
  }
  .updateList {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 10px;
    margin-top: 20px;
    list-style: inside;
  }
  .updateForm {
    margin: 20px;
  }
  .updateForm input {
    cursor: pointer;
    margin-top: 15px;
  }
</style>
